export default Object.freeze({
	AUTH: 'auth',
	APPLICATION_HUB: 'application-hub',
	HOME: 'home',
	START: 'start',

	// DIRECTORY
	LICENSE: 'license',
	USERS: 'users',
	DEVICES: 'devices',

	// ROUTING
	FLOW: 'flow',
	DIALPLAN: 'dialplan',
	GATEWAYS: 'gateways',
	CHATPLAN: 'chatplan',
	CHAT_GATEWAYS: 'chat-gateways',

	// LOOKUPS
	SKILLS: 'skills',
	BUCKETS: 'buckets',
	BLACKLIST: 'blacklists',
	REGIONS: 'regions',
	CALENDARS: 'calendars',
	COMMUNICATIONS: 'communications',
	PAUSE_CAUSE: 'agent-pause-cause',
	ACTIVITY_TYPES: 'activity-types',
	MEDIA: 'media',
	QUICK_REPLIES: 'quick-replies',

	// CONTACT-CENTER
	AGENTS: 'agents',
	TEAMS: 'teams',
	RESOURCES: 'resources',
	RESOURCE_GROUPS: 'resource-groups',
	QUEUES: 'queues',
	MEMBERS: 'queues-members',

	// INTEGRATIONS
	STORAGE: 'storage',
	STORAGE_POLICIES: 'storage-policies',
	COGNITIVE_PROFILES: 'cognitive-profiles',
	EMAIL_PROFILES: 'email-profiles',
	SINGLE_SIGN_ON: 'single-sign-on',
	IMPORT_CSV: 'import-csv',
	TRIGGERS: 'triggers',

	// PERMISSIONS
	OBJECTS: 'objects',
	ROLES: 'roles',

	// SYSTEM
	CHANGELOGS: 'changelogs',
	CONFIGURATION: 'configuration',
	GLOBAL_VARIABLES: 'global-variables',

	SETTINGS_PAGE: 'settings',
	PAGE_403: 'access-denied',
	PAGE_404: '',
});
